<app-modal
  [isOpen]="isOpen"
  [variant]="variant"
  [title]="title"
  [buttons]="footerButtons"
  (closed)="onCancel()"
>
  <div *ngIf="errorMessage" class="mb-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm font-medium">
    {{ errorMessage }}
  </div>
  <p>{{ message }}</p>
</app-modal>
